import { isNil } from "lodash"
export default class {

    /**
     * Inject the initial properties.
     *
     * @param Object props
     */
    constructor(props = {}) {
        this.reset(props)
    }

    /**
     * Reset the properties to the initial values.
     *
     * @param Object props
     *
     * @return self
     */
    reset(props = {}) {
        this.props = {
            pin: '',
            account: {
                id: '',
                name: '',
                email: '',
            },
            sources: [],
            payments: [],
            ... props
        }

        return this
    }

    /**
     * Get the value of the key from the properties or use the default.
     *
     * @param  string|null key
     * @param  mixed initial
     *
     * @return mixed
     */
    get(key = null, initial = null) {
        if( isNil(key) ) {
            return this.props
        }

        return this.props[key] || initial
    }

    /**
     * Set the value at the key in the properties.
     *
     * @param  string key
     * @param  mixed value
     *
     * @return self
     */
    set(key, value = null) {
        this.props[key] = value
        return this
    }
}
